export class UserProfileModel {
  UserProfile: string = "";
  ProfileUpdate: string = "";
  PasswordFormat: string = "";
  PasswordMsg: string = "";
  RoleUpdateMsg: string = "";
}
